import '../globals/Modal.css';

import React from 'react';
import { IonIcon, IonModal } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { HoursIcon } from './icons/HoursIcon';
import { FormattedMessage } from 'react-intl';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { PinIcon } from './icons/PinIcon';
import { PhoneIcon } from './icons/PhoneIcon';
import { MarkerModalType } from '../../model/map/map';

export const MarkerModal: React.FC<MarkerModalType> = ({
  showModal,
  setShowModal,
  currentSelectedPlace,
}) => {
  return (
    <IonModal
      isOpen={showModal}
      cssClass="map absolute top-0 right-0 !left-auto !bottom-auto flex items-end h-full w-full md:w-[calc(100%-16rem)] !m-0"
      swipeToClose={true}
      animated={true}
      backdropDismiss={true}
      onDidDismiss={() => setShowModal(false)}
    >
      <div
        onClick={() => setShowModal(false)}
        className="absolute top-0 custom-backdrop h-full w-full z-[20003] md:hidden"
      ></div>
      <div className="absolute bottom-0 p-5 rounded-t-3xl bg-black h-auto w-full z-[20004] md:bg-white md:h-full md:px-8 md:pt-12 md:pb-8 md:rounded-none">
        <div className="w-16 h-0.5 bg-gray-500 m-auto mb-3 rounded-full md:hidden"></div>
        <div
          className={`hidden md:block modal-cross z-50 absolute top-6 left-6 md:top-9 md:left-9`}
        >
          <div className="flex justify-center items-center w-0 h-0 p-3 rounded-full bg-primary">
            <Link to={'/pages/map'} style={{ lineHeight: 0 }}>
              <IonIcon
                className="text-white text-l leading-none"
                icon={closeOutline}
                onClick={() => setShowModal(false)}
              />
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-start mb-5 md:items-center md:mb-10">
          {currentSelectedPlace?.acf.place_house_img && (
            <img
              className="hidden rounded-full w-20 h-20 mb-4 md:block"
              src={currentSelectedPlace.acf.place_house_img}
              alt=""
            />
          )}
          <h2
            className="text-white font-bold text-xl text-left md:text-black md:text-center"
            dangerouslySetInnerHTML={{
              __html: currentSelectedPlace.title.rendered,
            }}
          ></h2>
        </div>
        <div className="flex flex-col">
          <h3 className="text-white text-base font-bold mb-6 md:text-black">
            <FormattedMessage id="Reception" />
          </h3>
          {currentSelectedPlace.acf.place_hours && (
            <p className="flex gap-4 flex-wrap items-start font-medium border-b border-gray-700 pb-5 mb-5 leading-5 text-white md:text-black md:border-gray-50">
              <HoursIcon className="mt-1" />
              <SanitizeHTML
                html={currentSelectedPlace.acf.place_hours}
                tag="span"
              />
            </p>
          )}
          {currentSelectedPlace.acf.place_phone && (
            <a
              href={
                'tel:+33' + currentSelectedPlace.acf.place_phone.substring(3)
              }
              className="flex gap-4 flex-wrap items-start font-medium border-b border-gray-700 pb-5 mb-8 leading-5 text-white md:text-black md:border-gray-50"
            >
              <PhoneIcon />
              <SanitizeHTML
                html={currentSelectedPlace.acf.place_phone}
                tag="span"
              />
            </a>
          )}

          {currentSelectedPlace.acf.place_access && (
            <>
              <h3 className="text-white text-base font-bold mb-6 md:text-black">
                <FormattedMessage id="Access" />
              </h3>
              <div className="grid grid-cols-[2fr,1fr] gap-4 items-center pb-5 border-b border-gray-700 md:border-gray-50">
                <p className="flex gap-4 items-start font-medium leading-5 text-white md:text-black">
                  <PinIcon className="mt-1" />
                  <SanitizeHTML
                    html={currentSelectedPlace.acf.place_access}
                    tag="span"
                  />
                </p>
                {currentSelectedPlace.acf.place_access && (
                  <a
                    className="bg-primary bg-opacity-20 text-primary text-center py-3 px-5 rounded-5xl hover:bg-secondary md:bg-opacity-100 md:text-white cursor-pointer"
                    rel="noreferrer"
                    href={currentSelectedPlace.acf.place_access_link}
                    target="_blank"
                  >
                    <FormattedMessage id="Itinerary" />
                  </a>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </IonModal>
  );
};
